///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.uploader = abcsetup.uploader || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.uploader.button = [];
abcsetup.uploader.uploadResult = {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    abcsetup.uploader.init();

    $('#uploader-modal').on('show.bs.modal', function (e) {
        $('#uploader-modal').find('.progress-bar').css('width', '0%').attr('aria-valuenow', 0).html('');
    });
});


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.uploader = {
    init: function () {
        // Upload button clicked
        $(document).on('click', 'button.btn-attachment, .btn-upload', function () {
            abcsetup.uploader.button = $(this);
            $('form.uploader').remove();

            let field = $(this).data('multi')
                ? '<input name="file[]" id="file" type="file" multiple>'
                : '<input name="file" id="file" type="file">';

            // Dynamically create the fields to submit along with the file
            const data = $(this).data();
            for (const i in data) {
                field += '<input type="hidden" name="' + i + '" value="' + data[i] + '">';
            }

            let route = '/attachments/upload';

            if ($(this).data('route')) {
                route = $(this).data('route');
            }

            const method = $(this).data('method') ? $(this).data('method') : 'POST';
            const token = document.head.querySelector('meta[name="csrf-token"]');

            $('body').append('<form method="' + method + '" class="uploader hide" action="' + route + '" enctype="multipart/form-data">' + field + '</form>');
            // TODO: support CSRF
            //$('form.uploader').append('<input name="_token" type="hidden" value="' + token.content + '">')
            $('form.uploader #file').click();
            return false;
        });

        // File selector has been changed
        $(document).on('change', 'form.uploader #file', function () {
            abcsetup.uploader._uploadFile($('form.uploader'));
        });

        // Remove buttons that have been attached already (and are using the autoappend feature)
        $('a.attachment-link-thumb').each(function () {
            var idx = $(this).data('type');
            console.log('idx', idx);
            if (idx) {
                $('button#' + idx + '[data-autoappend=true]:not([data-allow_replace=true])').removeClass('required');
                if (idx != 'ahp_pricing_letter' && idx != 'mwi_pricing_letter') {
                    $('button#' + idx + '[data-autoappend=true]:not([data-allow_replace=true])').hide();
                }
                else {
                    $('button#' + idx + '[data-autoappend=true]:not([data-allow_replace=true])').removeClass('btn-danger');
                }
            }
        });

        // Delete attachment button clicked (and are using the autoappend feature)
        $(document).on('click', '.delete-attachment-autoappend', function (event) {
            event.preventDefault();
            const _this = $(this);

            let attachment_type = _this.data('type');
            let message = 'Are you sure you want to delete this attachment?';

            if (attachment_type && attachment_type.includes("product_image__promo_item") && abcsetup.page_name == 'promos.items.edit') {
                message = 'Are you sure you want to delete this Product Image?  This is the current product image on file for this item.  If you delete it, you will need to upload your own image before you can submit this item for promotion.  If you wish to use the product image on file, you will need to remove this item from the promotion and re-add it to re-establish the link to the image on file.  Also, if the image on file is not correct, please initiate item maintenance to replace the image on file.';
            }

            abcsetup.alerts.confirm('Delete Attachment', message, function (resp) {
                if (!resp) {
                    return;
                }

                _this.parent().fadeOut('slow', function () {
                    // Find the attachment input field by value
                    const field = $('input.attachment_file').filter(function () {
                        return $(this).val() == _this.data('id');
                    });

                    // Show the attachment button again and null the value
                    if (_this.data('type')) {
                        const button = _this.closest('.attachments').find('button#' + _this.data('type') + (_this.data('btn_idx') ? `__${_this.data('btn_idx')}__` : ''));
                        button.show();
                        field.val('').trigger('change');
                        const stillHaveAttachmentsOfThisType = $('input.attachment_file[data-idx="' + _this.data('type') + '"]')
                            .toArray()
                            .some(idInput => Boolean(idInput.value));

                        if (!stillHaveAttachmentsOfThisType && ($(field).is(':required') || button.data('required') || button.hasClass('was_required'))) {
                            // Make the button red again AND re-require the hidden input field
                            button.removeClass('btn-primary').addClass('btn-danger').addClass('was_required');
                            field.attr('required','required');
                        }

                        if (stillHaveAttachmentsOfThisType && button.data('multi')) {
                            field.remove();
                        }

                        // Specific button not found (assume it's "other files")
                    } else {
                        field.remove();
                    }

                    $(this).remove();
                    abcsetup.loadRouteJS('attachmentRemoved');
                });
            });
        });

        $(document).on('click', '.ekko-lightbox .toggle-size-btn', function () {
            const image = $('.ekko-lightbox-container iframe').get(0).contentDocument.querySelector('img');

            if (image) {
                let newHeight = 'auto';
                let newWidth = 'auto';

                if (image.width > image.height) {
                    newWidth = '100vw';
                } else { // Assuming their monitor is more wide than tall for the case where width and height are equal.
                    newHeight = '100vh';
                }

                $(image).css('height', newHeight);
                $(image).css('width', newWidth);
                $(this).data('lastHeight', newHeight);
                $(this).data('lastWidth', newWidth);
            }
        });

        // Call the page specified uploadInit function
        abcsetup.loadRouteJS('uploadInit');
    },

    /**
     *
     */
    buildUploaderButton: function (button, callback = null) {
        const required = (button.required == 1) ? 'required btn-danger' : '';
        const mltpl = button.multi == 1;

        const btn = $("<button type='button' id='" + button.idx + "' class='btn btn-primary btn-attachment mr-2 " + required + "' data-type='" + button.idx + "' data-multi='" + mltpl + "' data-rule='" + button.rule + "'/>").html(button.name);

        if (callback) {
            callback(btn);
        }
    },

    /**
     * Upload the file in the specified form elem
     *
     */
    _uploadFile: function (formElem) {
        const _this = this;
        $('#uploader-modal').modal('show');

        formElem.ajaxForm({
            //beforeSubmit: validate,
            beforeSend: function () {
                $('#uploader-modal').find('.progress-bar').css('width', '0%').attr('aria-valuenow', 0).html('');
            },

            uploadProgress: function (event, position, total, percentComplete) {
                $('#uploader-modal').find('.progress-bar').css('width', percentComplete + '%').attr('aria-valuenow', percentComplete).html(percentComplete + '%');
            },

            success: function () {
                //$('#uploader-modal').find('.progress-bar').css('width', '100%').attr('aria-valuenow', 100).html('100%');
                $('#uploader-modal').find('.progress-bar').css('width', '100%').attr('aria-valuenow', 100).html('Wait, Saving');
            },

            complete: function (xhr) {
                $('form.uploader').remove();
                //$('#uploader-modal').modal('hide');

                // The upload failed
                if (xhr.status != 200) {
                    _this._hideUploadModal();
                    abcsetup.alerts.showErrors(xhr.responseJSON);
                    return;
                }

                // Set the global result var
                abcsetup.uploader.uploadResult = xhr.responseJSON;

                const replacePromise = abcsetup.uploader.button.data('replace_route')
                    ? axios.put(abcsetup.uploader.button.data('replace_route'), {
                        original_uuid: abcsetup.uploader.button.data('replace_uuid'),
                        new_uuid: abcsetup.uploader.uploadResult.upload_uuid,
                    })
                    : Promise.resolve();

                replacePromise.then(() => {
                    _this._hideUploadModal();

                    abcsetup.attachments.width = $(window).width() - 200;
                    abcsetup.attachments.height = $(window).height() - 100;

                    // Auto append the uploaded attachment rather than using a callback
                    if (abcsetup.uploader.button.data('autoappend')) {
                        abcsetup.loadRouteJS('uploadDoneBeforeAutoAppend');
                        _this._appendNewFile();
                        $('.attachment-link-thumb').each(function () {
                            var url = $(this).attr('href').replace('download/', 'preview/');
                            var title = $(this).text().trim();
                            //var title = $(this).find('small').text().trim();
                            //title = title.find('small').remove().text().trim();

                            $(this).find('img').wrap('<a href="' + url + '" class="" data-toggle="lightbox" data-title="' + title + '" data-footer="<button type=\'button\' class=\'btn btn-secondary toggle-size-btn\' data-last-height=\'auto\' data-last-width=\'auto\'>Toggle Size</button><a href=' + $(this).attr('href') + ' class=\'btn btn-primary\'>Download</a>" data-type="url" data-disable-external-check="true" data-width="' + abcsetup.attachments.width + '" data-height="' + abcsetup.attachments.height + '" data-alwaysShowClose="true" title="Preview"></a>');
                        });

                        abcsetup.loadRouteJS('uploadDoneAfterAutoAppend');
                    } else {
                        // Call the page specified uploadDone function
                        abcsetup.loadRouteJS('uploadDone');
                    }
                }).catch(error => {
                    _this._hideUploadModal();

                    if (error instanceof Error) {
                        console.error('error:', error);
                        abcsetup.alerts.show('Submission Errors', 'We\'ve encountered an internal error - please try again and contact support if this continues');
                    } else {
                        abcsetup.alerts.showErrors(error.data);
                    }
                });
            },
        }).submit();
    },

    _hideUploadModal() {
        const maxAttempts = 5;
        let attempts = 1;
        const uploaderModal = $('#uploader-modal');

        uploaderModal.modal('hide'); // This is all we should need to do to hide the modal. But, in some cases, it lingers. So, we'll try a few times.
        const intervalID = window.setInterval(() => {
            uploaderModal.modal('hide');
            attempts++;

            if (!uploaderModal.is(':visible') || attempts >= maxAttempts) {
                window.clearInterval(intervalID);
            }
        }, 300);
    },

    _makeFileDisplay(uploadedFile) {
        const thumbnailSize = abcsetup.uploader.button.data('thumb_size') || 72;
        let button = `<a href="/attachments/download/${uploadedFile.upload_uuid}" class="col-12 col-md-3 text-center attachment-link-thumb uuid-${uploadedFile.upload_uuid}" target="_blank">
                        <img src="/attachments/thumb/${uploadedFile.upload_uuid}?size=${thumbnailSize}" ${abcsetup.uploader.button.data('thumb_size') ? `class="p-3 w-100" style="max-width: ${thumbnailSize}px"` : ''}>
                        <br>`;

        // Show the type name if we have one
        if (uploadedFile.type_name) {
            button = button + uploadedFile.type_name + '<br>';
        }

        button += '<small>' + uploadedFile.filename + '</small>';

        if (abcsetup.uploader.button.data('allow_delete') !== false) { // defaulting to true
            // btn_idx will be set from the Attachment Controller, This is to allow duplicate data-types on the same page for entities like the PromoPageBlocks
            button += ' <i class="far fa-trash-alt text-danger delete-attachment-autoappend" title="Delete Attachment" data-type="' + uploadedFile.type + (uploadedFile.btn_idx ? "__" + uploadedFile.btn_idx + "__" : "") + '" data-id="' + uploadedFile.id + '"></i>';
        }

        if (abcsetup.uploader.button.data('replace_route')) {
            button += `
<br>
<button class="btn btn-sm btn-primary btn-upload"
        data-type="${abcsetup.uploader.button.data('type')}"
        data-uploadtype="${abcsetup.uploader.button.data('uploadtype')}"
        data-autoappend="true"
        data-allow_delete="${abcsetup.uploader.button.data('allow_delete')}"
        data-replace_uuid="${uploadedFile.upload_uuid}"
        data-replace_route="${abcsetup.uploader.button.data('replace_route')}">
    Replace
</button>`;
        }

        return button + '</a>';
    },

    /**
     * Append all of the uploaded file(s).
     *
     * @private
     */
    _appendNewFile: function () {
        const uploadedFiles = Array.isArray(abcsetup.uploader.uploadResult)
            ? abcsetup.uploader.uploadResult
            : [abcsetup.uploader.uploadResult];
        // This is only for the first uploaded file.
        const upload_btn_idx = uploadedFiles[0].type + (uploadedFiles[0].btn_idx ? "__" + uploadedFiles[0].btn_idx + "__" : "");
        const row = abcsetup.uploader.button.closest('.attachments');
        const attachmentsContainer = row.find('.existing .row');
        const attachmentTypeButton = row.find('button#' + upload_btn_idx); // I wonder if we should use abcsetup.uploader.button for this instead.
        const allowsMultiple = Boolean(attachmentTypeButton.data('multi'));
        const makeHiddenAttachmentIdField = function(button, file, typeId = null) {
            var input = $('<input type="text" class="attachment_file" name="' + (button.data('fieldname') || 'file_attachments[]')+ '" autocomplete="off" ' + (typeId ? 'fieldvalidate="attachmentFile" data-idx="'+typeId+'"' : '') + ' ' + (button.data('required') ? 'required' : '') + '/>').val(file.id);
            return input;
        }

        // Find the parent attachments div
        attachmentsContainer.append(uploadedFiles.map(uploadedFile => this._makeFileDisplay(uploadedFile)).join(''));

        if (abcsetup.uploader.button.data('replace_uuid')) {
            attachmentsContainer.find(`.uuid-${abcsetup.uploader.button.data('replace_uuid')}`).remove();
            abcsetup.uploader.button.data('replace_uuid', uploadedFiles[0].upload_uuid);
        }

        if (attachmentTypeButton.length === 0) {
            // Attachment type button not found (assume it's "other files")
            row.find('.existing .row').append(makeHiddenAttachmentIdField(abcsetup.uploader.button, uploadedFiles[0]));
            return;
        }

        attachmentTypeButton
            .addClass('btn-primary') // Assuming the button's default is "primary".
            .removeClass('required')
            .removeClass('btn-danger');

        if (Boolean(attachmentTypeButton.data('persistent_button')) === false && // Client asked to keep the button around?
            allowsMultiple === false && // We're allowing multiple files to be uploaded?
            Boolean(attachmentTypeButton.data('allow_replace')) === false) { // We're allowing an existing file to be replaced with a new one without having to delete the existing?
            attachmentTypeButton.hide();
        }

        if (allowsMultiple) {
            const fileIdsContainer = attachmentTypeButton.closest('.uploader-container').length
                ? attachmentTypeButton.closest('.uploader-container')
                : attachmentTypeButton.closest('.attachment-button-container');

            if (fileIdsContainer.length) {
                fileIdsContainer.append(
                    uploadedFiles.map(uploadedFile => makeHiddenAttachmentIdField(abcsetup.uploader.button, uploadedFile, abcsetup.uploader.button.data('type')))
                );

                // It's possible we'll have an empty input from when we first loaded the form or from removing all the files. Removing it only matters if it's a required field.
                // fileIdsContainer.find('input.attachment_file').filter((idx, input) => !input.value).remove();
                // ONLY apply this to the fields for the attachment type we're currently dealing with here
                fileIdsContainer.find('input.attachment_file').filter(function(idx, input) {
                    if ($(input).data('idx') == uploadedFiles[0].type){
                        return !input.value;
                    }
                    return false;
                }).remove();
            } else {
                abcsetup.alerts.show('Error Uploading Attachments', 'We\'ve encountered an internal error - please try again and contact support if this continues');
            }
        } else {
            // This was replaced with the filtering we have below on 10/27/2020 in 0395d6. Keeping this around for now, but we may be able to delete it.
            //abcsetup.uploader.button.next('.attachment_file').val(uploadedFiles[0].id).trigger('change');

            let field = $('input.attachment_file[data-idx="' + upload_btn_idx + '"]').filter(function () {
                // I'm not sure why we're filtering out inputs that already have a value. I guess with the way it originally
                // worked where we'd upload and then only be able to upload again after removing the file of that type, we
                // know that ID field will be blank because it should've been removed before attempting to upload another.
                return !$(this).val();
            });

            if (field.length === 0 && attachmentTypeButton.parent('.attachment-button-container').length === 1) {
                field = attachmentTypeButton.parent('.attachment-button-container').find('input.attachment_file')
            }

            if (field.length > 0) {
                field.val(uploadedFiles[0].id).trigger('change');

                // Assume it's a new attachment for the uploaded type
            } else {
                //row.find('button#' + upload_btn_idx)
                abcsetup.alerts.show('Error Uploading Attachment', 'We\'ve encountered an internal error - please try again and contact support if this continues');
            }
        }

        row.find('.errorMsg').remove();
    },
}
